import { render } from "./ProductMainsection.vue?vue&type=template&id=3f527065&scoped=true"
import script from "./ProductMainsection.vue?vue&type=script&lang=js"
export * from "./ProductMainsection.vue?vue&type=script&lang=js"

import "./ProductMainsection.vue?vue&type=style&index=0&id=3f527065&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f527065"]])

export default __exports__